module.exports = "/next-static/_next/static/images/block_image_live_video-60b3b5b95d6beef41b59593c0da752de.png";